/**
 * Wiek aktywnej oferty w pełnych godzinach (floor), z podłogą 1 godz.
 * createdAt: ISO LocalDateTime bez strefy (czas serwera = Europe/Warsaw = strefa
 * użytkownika w PL), więc różnica względem Date.now() jest poprawna.
 * Zwraca null gdy brak createdAt (nie renderujemy wtedy nic).
 */
export function offerAgeHours(createdAt) {
    if (!createdAt) return null;
    const ms = Date.now() - new Date(createdAt).getTime();
    return Math.max(1, Math.floor(ms / 3600000));
}
